import { Button, notification } from 'antd';
import React from 'react'
import { PhotoButtons, PhotoWrap } from './style';
import { DeleteOutlined, FileMarkdownOutlined } from '@ant-design/icons';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ASSETS_URL, deleteConnectedPhoto, postArticleMainPhoto } from '../../services/api';

type PhotoType = {
    alt?: string;
    src: string;
    photoId: string;
    contentId: any;
    main: number;
}

const Photo = ({alt, contentId, photoId, src, main}: PhotoType) => {
    
    const queryClient = useQueryClient();
    const [ ntf, contextHolder ] = notification.useNotification();
    const { mutate: mutateMainPhoto } = useMutation(postArticleMainPhoto);
    const { mutate: mutateDisconnectPhoto } = useMutation(deleteConnectedPhoto);

    const handleSetMainPhoto = () => {
        mutateMainPhoto({contentId: contentId, photoId: photoId }, {
            onSuccess() {
                queryClient.invalidateQueries(['photos-blog']);
                ntf.success({
                    message: `Success`,
                    description: "This photo is now main photo!",
                    placement: "bottomLeft",
                });
            },
            onError() {
                ntf.error({
                    message: `Error`,
                    description: "Something gonne wrong!",
                    placement: "bottomLeft",
                });
            },
        })
    }

    const handleDisconnectPhoto = () => {
        mutateDisconnectPhoto({contentId: contentId, photoId: photoId }, {
            onSuccess() {
                queryClient.invalidateQueries(['photos-blog']);
                ntf.success({
                    message: `Success`,
                    description: "Photo is disconnected!",
                    placement: "bottomLeft",
                });
            },
            onError() {
                ntf.error({
                    message: `Error`,
                    description: "Something gonne wrong!",
                    placement: "bottomLeft",
                });
            },
        })
    }
    
    return (
        <PhotoWrap>
            {contextHolder}
            <img src={`${ASSETS_URL}photos/uploads/${src}`} alt={alt} />
            <PhotoButtons>
                {main === 0 && <Button icon={<FileMarkdownOutlined />} onClick={() => handleSetMainPhoto()}>As main photo</Button>}
                <Button danger type="primary" icon={<DeleteOutlined />} onClick={() => handleDisconnectPhoto()}>Disconnect photo</Button>
            </PhotoButtons>
        </PhotoWrap>
    )
}

export default Photo